export const schoolCalendar = {
  title: "Calendrier Scolaire",
  subtitle: "Année scolaire 2026/2027 - Dates importantes et événements de l'année académique",
  courseDate: {
    title: "Début et fin des cours",
    start: "Début des cours",
    startDate: "9 septembre 2026",
    end: "Fin des cours",
    endDate: "21 juin 2027"
  },
  holidays: {
    title: "Vacances",
    items: [
      {
        name: "Noël",
        date: "du 22 décembre 2026 au 7 janvier 2027 (inclus)"
      },
      {
        name: "Entroido (Carnaval)",
        date: "8, 9 et 10 février 2027 (inclus)"
      },
      {
        name: "Pâques",
        date: "du 22 au 29 mars 2027 (inclus)"
      }
    ]
  },
  publicHolidays: {
    title: "Jours fériés",
    items: [
      {
        name: "Fête Nationale",
        date: "12 octobre 2026"
      },
      {
        name: "Immaculée Conception",
        date: "8 décembre 2026"
      },
      {
        name: "San Xosé (Fête des Pères)",
        date: "19 mars 2027"
      },
      {
        name: "Fête du Travail",
        date: "1er mai 2027"
      },
      {
        name: "Letras Galegas",
        date: "17 mai 2027"
      }
    ]
  },
  nonSchoolDays: {
    title: "Jours non scolaires (Xunta)",
    items: [
      {
        name: "Día do Ensino",
        date: "7 décembre 2026"
      }
    ]
  },
  familyCelebrations: {
    title: "Célébrations à Gándara (avec les familles)",
    items: [
      {
        name: "Samaín-Magosto",
        date: "30 octobre 2026"
      },
      {
        name: "Solstice d'hiver",
        date: "21 décembre 2026"
      },
      {
        name: "Entroido",
        date: "5 février 2027"
      },
      {
        name: "Équinoxe de printemps",
        date: "18 mars 2027"
      },
      {
        name: "Fête de fin d'année",
        date: "21 juin 2027"
      }
    ]
  },
  familyMeetings: {
    title: "Réunions avec les familles",
    items: [
      {
        name: "Réunion de début d'année",
        date: "7 septembre 2026"
      },
      {
        name: "Réunion du 2e trimestre",
        date: "14 décembre 2026"
      },
      {
        name: "Réunion de fin d'année",
        date: "14 juin 2027"
      }
    ]
  }
};
